export default {
  // 获取产品列表
  GET_LIST_PRODUCT: '/jcnapi/product/getList',
  DEL: '/jcnapi/product/delete',
  //保存
  SAVE: '/jcnapi/product/save',
  GET: '/jcnapi/product/getBanner',
  SET_BANNER: '/jcnapi/product/setBanner',
  //获取产品分类列表
  GET_LIST: '/jcnapi/product/type/getList',
  SAVE_TYPE: '/jcnapi/product/type/save',
  DEL_TYPE: '/jcnapi/product/type/delete',
  //产品可选功能
  SAVE_OTHER: '/jcnapi/product/other/save',
  GET_LIST_OTHER: '/jcnapi/product/other/getList',
  DEL_OTHER: '/jcnapi/product/other/delete',
  GET_INFO: '/jcnapi/product/getInfo'
}



// WEBPACK FOOTER //
// ./src/data/apiUrl/modules/product/index.js